// Per-app Stimulus manifest. Shared controllers come from the fvbox gem via
// registerFvboxControllers; register tbap-specific controllers below.

import { application } from "fvbox/application"
import { registerFvboxControllers } from "fvbox"

// Shared controllers (hello, turbomodal, timezone-detector, ...) from the gem
registerFvboxControllers(application)

// tbap-specific controllers
import AutofillDescriptionController from "./autofill_description_controller"
application.register("autofill-description", AutofillDescriptionController)

import AutofillCoverController from "./autofill_cover_controller"
application.register("autofill-cover", AutofillCoverController)
